import { FeatureDomain, LogEventType } from '@akin-home/amplify';
import { AppOpenLogEvent } from '@akin-home/logging';
import { postLogEvent, PostLogEventParams } from './postLogEvent';

type Params = Omit<PostLogEventParams<AppOpenLogEvent['data']>, 'type'>;

export const postAppOpenLogEvent = (params: Params) =>
  postLogEvent({
    ...params,
    feature_domain: FeatureDomain.APPS,
    type: LogEventType.APP_OPEN,
  });
